import { render, staticRenderFns } from "./TrainerContract.vue?vue&type=template&id=1329cba2&"
import script from "./TrainerContract.vue?vue&type=script&lang=js&"
export * from "./TrainerContract.vue?vue&type=script&lang=js&"
import style0 from "./TrainerContract.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "TrainerContract.vue"
export default component.exports